import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

interface ModalProps {
  isOpen: boolean;
  toggle: () => void;
  title?: string;
  children: React.ReactNode;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  isTitleCentered?: boolean;
  onSave?: () => void;
  disabledBtn?: boolean;
}

const CustomModal: React.FC<ModalProps> = ({
  isOpen,
  toggle,
  title = "Modal Title",
  children,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isTitleCentered = true,
  onSave,
  disabledBtn = true,
}) => {
  return (
    <Modal className="custom-content-modal" isOpen={isOpen} toggle={toggle} centered backdrop="static" keyboard={false}>
      <ModalHeader className={`${isTitleCentered ? "text-center mx-auto" : "text-start title-heading-page"} `}>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <button className="cancel-text" onClick={toggle}>
          {cancelText}
        </button>
        {onConfirm && (
          <button className={"confirm-text"} onClick={onConfirm}>
            {confirmText}
          </button>
        )}
        {onSave && (
          <button disabled={disabledBtn} className={` ${disabledBtn ? "inactive" : ""} save-text`} onClick={onSave}>
            {confirmText}
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default CustomModal;
